module.exports = __webpack_public_path__ + "static/media/solution-2-sec1.3d625f96.png";